import axios from "axios";
import { handleResponse } from "./HelperService";

const getWithdrawalList = (params, onSuccess, onError) => {
  const response = axios.get("v1/ipg-withdrawal/withdrawal-list", { params });
  return handleResponse(response, onSuccess, onError);
};

const getXenditStagedHistory = (params, onSuccess, onError) => {
  const response = axios.get("v1/salesorder_payment/history-xendit", {
    params,
  });
  return handleResponse(response, onSuccess, onError);
};

const getXenditStagedHistoryDetail = (params, onSuccess, onError) => {
    const response = axios.get(`v1/salesorder_payment/history-xendit/${params}`);
    return handleResponse(response, onSuccess, onError);
  };  

const getWithdrawalListDetail = (id, onSuccess, onError) => {
  const response = axios.get(`v1/ipg-withdrawal/withdrawal-list-detail/${id}`);
  return handleResponse(response, onSuccess, onError);
};

const getBalanceDashboardData = (mhc, onSuccess, onError) => {
  console.log('MHCX',mhc);
  const response = axios.get(`v1/salesorder_payment/balance-dashboard` + (mhc && mhc !== "" ? `?mhc=${mhc}` : ""));
  return handleResponse(response, onSuccess, onError);
};

const getWithdrawalBank = (mhc, onSuccess, onError) => {
  const response = axios.get(`v1/ipg-withdrawal/withdrawal-list-bank/${mhc}`);
  return handleResponse(response, onSuccess, onError);
};

const postWithdrawalRequest = (payload, onSuccess, onError) => {
  const response = axios.post(
    `v1/ipg-withdrawal/withdrawal-submit-request`,
    payload
  );
  return handleResponse(response, onSuccess, onError);
};

export {
  getWithdrawalList,
  getWithdrawalListDetail,
  getWithdrawalBank,
  postWithdrawalRequest,
  getXenditStagedHistory,
  getBalanceDashboardData,
  getXenditStagedHistoryDetail
};
